import { useEffect, useState } from "react";

const useScreenHeight = () => {
  // clientHeight is the layout viewport height — always zoom-immune and never
  // affected by visual-viewport scale changes (no transient ScreenTooSmall).
  // It also updates correctly in landscape without needing scale division.
  const getHeight = () => document.documentElement.clientHeight;

  const [screenHeight, setScreenHeight] = useState<number>(getHeight);

  useEffect(() => {
    const handleResize = () => setScreenHeight(getHeight());

    // On orientationchange, read dimensions after the viewport has settled.
    // WKWebView may not update clientHeight until ~100–150ms after the event;
    // waiting 200ms guarantees we read the correct landscape value.
    let orientationTimer: ReturnType<typeof setTimeout>;
    const handleOrientationChange = () => {
      clearTimeout(orientationTimer);
      orientationTimer = setTimeout(() => setScreenHeight(getHeight()), 200);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleOrientationChange);
    return () => {
      clearTimeout(orientationTimer);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);

  const mobileBreakpoint = 925;
  const tabletBreakpoint = 1024;
  const laptopBreakpoint = 768;
  const largeLaptopBreakpoint = 720;
  const desktopBreakpoint = 810;
  const fullHDBreakpoint = 1080;
  const twoKBreakpoint = 1440;
  const fourKBreakpoint = 2160;
  const fiveKBreakpoint = 2880;

  return {
    screenHeight,
    mobileBreakpoint,
    tabletBreakpoint,
    laptopBreakpoint,
    largeLaptopBreakpoint,
    desktopBreakpoint,
    fullHDBreakpoint,
    twoKBreakpoint,
    fourKBreakpoint,
    fiveKBreakpoint,
  };
};

export default useScreenHeight;
